export const CONTACT_EMAIL = 'info@sglproperty.org';
export const PROPERTY_ADDRESS = '6028 Sheridan Drive, Williamsville, NY 14221';
export const ORIGINAL_PRICE = 795000;
export const CURRENT_PRICE = 675000;
export const PRICE_REDUCTION = 120000;
export const PRICE_PER_SF = 77.59;
export const BUILDING_SIZE = 8700;
export const PARKING_SPACES = 30;
export const LOT_SIZE = '0.61 acres';
export const YEAR_BUILT = 1975;
export const BUILDING_CLASS = 'B';
export const DRONE_VIDEO_URL = ''; // Add actual URL when available
export const LOOPNET_ID = '31418462';
